import type { Graph } from "@lr-notitia/notitia-operator/schemas";
import { api } from "@lr-notitia/notitia-operator/client";
import { ref } from "vue";
import { defineStore } from "pinia";
import { newGraph } from "./graph/utils";

export const useModelGraphStore = defineStore("modelGraph", () => {
	const domainId = ref("");
	const graph = ref<Graph>(newGraph());

	function loadGraph(dId: string): Promise<Graph> {
		domainId.value = dId;
		return new Promise((resolve, reject) => {
			api()
				.domain(domainId.value)
				.modelGraph()
				.get()
				.then((data) => {
					graph.value = data;
					resolve(data);
				})
				.catch(() => reject("Failed to load graph"));
		});
	}
	function clearGraph() {
		graph.value = newGraph();
		domainId.value = "";
	}

	return {
		graph,
		loadGraph,
		clearGraph,
	};
});
